// Animations handling

import { scrollEventThrottle } from './utils';

function activateAnimation(elem) {
    var animInterval = elem.dataset.animInterval;
    if (animInterval) {
        setInterval(function () {
            elem.classList.add('anim-activated');
        }, animInterval);
    } else {
        elem.classList.add('anim-activated');
    }
}

window.addEventListener('load', function() {

    // TODO should be using Intersection Observer API, but Safari support is crap...
    scrollEventThrottle((scrollPos, previousScrollPos) => {
        document.querySelectorAll('.anim:not(.anim-activated)').forEach(animElem => {
            if (animElem.getBoundingClientRect().top <= window.innerHeight * 0.75) {
                var animGroup = animElem.dataset.animGroup;
                if (animGroup) {
                    document.querySelectorAll(`.anim-${animGroup}`).forEach(function(elem) {
                        activateAnimation(elem);
                    });
                } else {
                    activateAnimation(animElem);
                }
            }
        });
    });
    window.dispatchEvent(new CustomEvent('scroll'));
});
